<template>
  <div class="about">
    <h1>Box - Sign In</h1>
    <div v-if="!loggedIn">
      <NeedLogin></NeedLogin>
    </div>
    <div v-else>
    <v-card outlined raised>
      <div>
        <!-- <div v-if="!isAlertVisible"> -->
        <OpenedEventList @selected-eventid="setEventId" :regId="regid"></OpenedEventList>
        <div v-if="!loggedIn">
          <UserApiSearch @selected-regid="setRegId"></UserApiSearch>
        </div>

        <v-form v-model="isValid">
          <v-row>
            <v-col>
              <div v-if="!loggedIn">
                <v-text-field
                  v-model="ac"
                  outlined
                  dense
                  required
                  prepend-inner-icon="mdi-lock-question"
                  placeholder="Access code"
                  :rules="acRules"
                  hint="Your access code"
                  :append-icon="eyevalue ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="() => (eyevalue = !eyevalue)"
                  :type="eyevalue ? 'password' : 'text'"
                ></v-text-field>
              </div>
            </v-col>
            <v-text-field
              v-model="eventid"
              outlined
              required
              :rules="eventidRules"
              readonly
              v-show="false"
            ></v-text-field>
            <v-text-field
              v-model="regid"
              outlined
              required
              :rules="regidRules"
              readonly
              v-show="false"
            ></v-text-field>
          </v-row>

          <v-row>
            <v-col></v-col>
            <v-col>
              <div v-if="!loggedIn"><v-icon small color="red">fas fa-lock</v-icon></div>
              <div v-if="loggedIn"><v-icon small color="green">fas fa-lock-open</v-icon></div>
            </v-col>
            <v-col>
              <v-btn
                :disabled="!isValid"
                color="primary"
                @click="submit"
                :class="`d-flex justify-space-around mb-6`"
                >SIGN IN <v-icon right small>fa-sign-in-alt</v-icon></v-btn
              >
            </v-col>
            <v-col>
              <v-btn
                color="lightgrey"
                link
                :to="cancellink.to"
                :class="`d-flex justify-space-around mb-6`"
                >{{ cancelBtnText }}</v-btn
              >
            </v-col>
            <v-col></v-col>
          </v-row>
        </v-form>
      </div>
      <v-alert type="success" :value="isAlertVisible" dense>
        {{ statusResultMsg }}
        <v-btn :to="cancellink.to" color="primary" style="margin-left: 6px;">OK</v-btn>
      </v-alert>
      <v-alert type="error" :value="isWarningAlertVisible" dense>{{
        statusResultMsg
      }}</v-alert>

      <div v-if="isWarningAlertVisible">
        <!-- <v-btn @click="sendAcOnMail" small rounded block>Forgot your access code? Send it by email.</v-btn> -->
        <v-btn :to="sendaclink.to" small rounded block
          >Forgot your access code? Send it...</v-btn
        >
      </div>
    </v-card>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import UserApiSearch from "@/components/airbox/UserApiSearch.vue";
// import EventSearch from "@/components/airbox/OpenedEventSearch.vue";
import OpenedEventList from "@/components/airbox/OpenedEventList.vue";
import NeedLogin from "@/components/Admin/NeedLogin.vue";
import axios from "axios";

export default {
  name: "CheckIn",
  // regid: Number,
  data() {
    return {
      regid: Number,
      eventid: Number,
      ac: null,
      eyevalue: true,
      isValid: true,
      acRules: [(v) => !!v || "Access code is required"],
      eventidRules: [(v) => !!v || "Event is required"],
      regidRules: [(v) => !!v || "User is required"],
      cancellink: { to: "/airbox/0" },
      sendaclink: { to: "/sendac" },
      isAlertVisible: false,
      isWarningAlertVisible: false,
      statusResult: Number,
      statusResultMsg: String,
      statusToken: Number,
      cookieToken: Number,
      cookieRegId: Number,
      loggedIn: false,
      cancelBtnText: "Cancel",
      statuses: [],
      errors: [],
    };
  },
  created() {
    this.baseUrl = "https://pgapi.azurewebsites.net/dbapi/";
    this.regid = null;
    this.eventid = null;
    this.isValid = false;
    this.getCookies();
    // console.log(this.loggedIn);
  },
  methods: {
    setRegId(id) {
      this.regid = id;
      // console.log(id);
    },
    setEventId(id) {
      this.eventid = id;
      // console.log(id);
    },
    submit() {
      var regId = this.regid;
      var statusId = 3;
      var eventId = this.eventid;
      var ac = this.ac;
      var comment = "";

      var toSubmit = JSON.stringify({ statusId, eventId, ac, comment });
      const uri = this.baseUrl + "setstatus/" + regId;
      //   console.log(uri)
      //   console.log(toSubmit)
      this.sendpost(uri, toSubmit, 1);
      this.cancellink = { to: "/airbox/" + this.eventid };
      
    },

    getAcValid() {
      var regId = this.regid;
      var ac = this.ac;
      var toSubmit = JSON.stringify({ ac });
      const uri = this.baseUrl + "getacvalid/" + regId;
      //   console.log(uri)
      //   console.log(toSubmit)
      this.sendpost(uri, toSubmit, 1);
    },

    sendAcOnMail() {
      var regId = this.regid;
      var toSubmit = JSON.stringify({});
      const uri = this.baseUrl + "emailac/" + regId;
      //   console.log(uri)
      //   console.log(toSubmit)
      this.sendpost(uri, toSubmit, 0);
    },

    sendpost(uri, toSubmit, type) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
        },
      };
      axios
        .post(uri, toSubmit, axiosConfig)
        .then((response) => {
          if (type === 0) {
            this.statusResult = response.data.Result;
            this.statusResultMsg = response.data.ResultMsg;
            this.statusToken = response.data.Token;
          } else {
            this.statusResult = response.data[0].Result;
            this.statusResultMsg = response.data[0].ResultMsg;
            this.statusToken = response.data[0].Token;
          }
          if (this.statusResult == 1) {
            this.cancelBtnText = "Done";
            this.isValid = false;
          }
          this.setAlert(this.statusResult);
          //this.savedToken = this.$cookies.get("pgboxtoken");
          //   if (this.statusResult === 1) {
          //       getstatus();
          //   }
          //console.log('response',response.data)
        })
        .catch((e) => {
          this.errors.push(e);
          this.statusResult = 0;
          this.statusResultMsg = "Something went wrong!";
          this.setAlert(this.statusResult);
        });
    },

    setAlert(statusResult) {
      if (statusResult === 1) {
        this.isAlertVisible = true;
        this.isWarningAlertVisible = false;
      }
      if (statusResult === 0) {
        this.isWarningAlertVisible = true;
        this.isAlertVisible = false;
      }
    },
    getCookies() {
      this.cookieRegId = this.$cookies.get("pgbregid");
      this.cookieToken = this.$cookies.get("pgbtoken");
      this.regid = this.cookieRegId;
      this.ac = this.cookieToken;
      if (this.cookieToken > 0) {
        this.loggedIn = true;
      }
    },
  },
  components: {
    UserApiSearch,
    // EventSearch
    OpenedEventList,
    NeedLogin
  },
};
</script>